// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { SoftwareObservationSchema } from './SoftwareObservationSchema'
import type { SoftwareObservation } from './SoftwareObservationSchema'
import { DomainWithRelationsSchema } from './DomainRelationsSchema'
import type { DomainWithRelations } from './DomainRelationsSchema'
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { NetworkServiceWithRelationsSchema } from './NetworkServiceRelationsSchema'
import type { NetworkServiceWithRelations } from './NetworkServiceRelationsSchema'
import { HostWithRelationsSchema } from './HostRelationsSchema'
import type { HostWithRelations } from './HostRelationsSchema'
import { SoftwareSchema } from './SoftwareSchema';

/////////////////////////////////////////
// SOFTWARE RELATION SCHEMA
/////////////////////////////////////////

export type SoftwareRelations = {
  observations: SoftwareObservation[];
  domain?: DomainWithRelations | null;
  surface: ExternalNetworkWithRelations;
  networkService?: NetworkServiceWithRelations | null;
  host?: HostWithRelations | null;
};

export type SoftwareWithRelations = z.infer<typeof SoftwareSchema> & SoftwareRelations

export const SoftwareWithRelationsSchema: z.ZodType<SoftwareWithRelations> = SoftwareSchema.merge(z.object({
  observations: z.lazy(() => SoftwareObservationSchema).array(),
  domain: z.lazy(() => DomainWithRelationsSchema).nullable(),
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  networkService: z.lazy(() => NetworkServiceWithRelationsSchema).nullable(),
  host: z.lazy(() => HostWithRelationsSchema).nullable(),
}))